import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { Text } from '@/components/typography';
import Image from 'next/image';
import React from 'react';
import { ImageItem } from './ImageItem';
import { MoreInfoButtons } from '@/sections/MoreInfo';
import { EXTERNAL_LINKS } from '@/constants/links';
import IconBlog from '@/assets/logos/socialMedia/blog-colored.svg';
import IconFacebook from '@/assets/logos/socialMedia/facebook-colored.svg';
import iconInstagram from '@/assets/logos/socialMedia/instagram-colored.png';
import IconLinkedin from '@/assets/logos/socialMedia/linkedin-colored.svg';
import IconYoutube from '@/assets/logos/socialMedia/youtube-colored.svg';
export function Social() {
  const $ = _c(52);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["aboutUs"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("social.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="social.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("social.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="text-center text-gray-800">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <ContentContainer className="max-w-192">{t2}{t4}</ContentContainer>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconFacebook className="fillButtonIcon" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("social.links.facebook");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = EXTERNAL_LINKS();
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = {
      analyticsParam: "aboutUsMoreInfoFacebook",
      icon: t6,
      testId: "aboutUsMoreInfoFacebook",
      title: t7,
      to: t8.facebook
    };
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconLinkedin className="fillButtonIcon" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("social.links.linkedin");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = EXTERNAL_LINKS();
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = {
      analyticsParam: "aboutUsMoreInfoLinkedin",
      icon: t10,
      testId: "aboutUsMoreInfoLinkedin",
      title: t11,
      to: t12.linkedIn
    };
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Image className="fillButtonIcon" width={40} height={40} src={iconInstagram} alt="Instagram" />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("social.links.instagram");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = EXTERNAL_LINKS();
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15) {
    t17 = {
      analyticsParam: "aboutUsMoreInfoInstagram",
      icon: t14,
      testId: "aboutUsMoreInfoInstagram",
      title: t15,
      to: t16.instagram
    };
    $[28] = t15;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <IconYoutube className="fillButtonIcon" />;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t) {
    t19 = t("social.links.youtube");
    $[31] = t;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = EXTERNAL_LINKS();
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t19) {
    t21 = {
      analyticsParam: "aboutUsMoreInfoYoutube",
      icon: t18,
      testId: "aboutUsMoreInfoYoutube",
      title: t19,
      to: t20.youtube
    };
    $[34] = t19;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconBlog className="fillButtonIcon" />;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t) {
    t23 = t("social.links.blog");
    $[37] = t;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = EXTERNAL_LINKS();
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t23) {
    t25 = {
      analyticsParam: "aboutUsMoreInfoBlog",
      icon: t22,
      testId: "aboutUsMoreInfoBlog",
      title: t23,
      to: t24.blog
    };
    $[40] = t23;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t13 || $[43] !== t17 || $[44] !== t21 || $[45] !== t25 || $[46] !== t9) {
    t26 = <MoreInfoButtons buttons={[t9, t13, t17, t21, t25]} />;
    $[42] = t13;
    $[43] = t17;
    $[44] = t21;
    $[45] = t25;
    $[46] = t9;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="mx-auto my-12 max-w-[23rem] lg:my-16 lg:max-w-292"><div className="grid grid-flow-col grid-cols-2 grid-rows-5 gap-4 lg:grid-cols-6 lg:grid-rows-2 lg:gap-8"><ImageItem src="/images/sections/aboutUs/team2/1.jpg" width={1} height={2} className="hidden lg:block" /><ImageItem src="/images/sections/aboutUs/team2/2-1.jpg" height={1} width={2} /><ImageItem src="/images/sections/aboutUs/team2/2-2-1.jpg" width={1} height={1} /><ImageItem src="/images/sections/aboutUs/team2/2-2-2.jpg" width={1} height={1} /><ImageItem src="/images/sections/aboutUs/team2/3.jpg" width={2} height={2} /><ImageItem src="/images/sections/aboutUs/team2/4-1.jpg" width={1} height={1} /><ImageItem src="/images/sections/aboutUs/team2/4-2.jpg" width={1} height={1} /></div></div>;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t26 || $[50] !== t5) {
    t28 = <div className="px-4">{t5}{t26}{t27}</div>;
    $[49] = t26;
    $[50] = t5;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  return t28;
}